import { ANALYTICS_HEARTBEAT_CAP_MS, ANALYTICS_HEARTBEAT_MS } from './config';

export type EngagementTracker = {
  start: () => void;
  stop: () => void;
  flushEngagedMs: () => number;
  isVisible: () => boolean;
};

export function createEngagementTracker(): EngagementTracker {
  let engagedMs = 0;
  let lastTick = 0;
  let intervalId: number | null = null;
  let visible = document.visibilityState === 'visible';

  const onVisibility = () => {
    visible = document.visibilityState === 'visible';
    if (visible) lastTick = Date.now();
  };

  const tick = () => {
    if (!visible) return;
    const now = Date.now();
    if (lastTick === 0) {
      lastTick = now;
      return;
    }
    const delta = now - lastTick;
    lastTick = now;
    engagedMs += Math.min(delta, ANALYTICS_HEARTBEAT_CAP_MS);
  };

  return {
    start() {
      if (intervalId !== null) return;
      lastTick = Date.now();
      document.addEventListener('visibilitychange', onVisibility);
      intervalId = window.setInterval(tick, ANALYTICS_HEARTBEAT_MS);
    },
    stop() {
      if (intervalId !== null) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
      document.removeEventListener('visibilitychange', onVisibility);
      tick();
    },
    flushEngagedMs() {
      tick();
      const value = engagedMs;
      engagedMs = 0;
      lastTick = Date.now();
      return value;
    },
    isVisible: () => visible,
  };
}
